import { z } from 'zod';
import { FaqEntry, PolicyView } from '../../help.js';
import { BroadcastInput, BroadcastPreview, BroadcastResult, BroadcastTarget, PublishPolicyInput, UpsertFaqInput, UpsertTemplateInput, } from './schemas.js';
export const adminContentRoutes = {
    publishPolicy: {
        method: 'POST',
        path: '/admin/policies',
        body: PublishPolicyInput,
        response: PolicyView,
    },
    upsertFaq: { method: 'PUT', path: '/admin/faq', body: UpsertFaqInput, response: FaqEntry },
    upsertTemplate: {
        method: 'PUT',
        path: '/admin/templates',
        body: UpsertTemplateInput,
        response: z.object({ id: z.string() }),
    },
    broadcastPreview: {
        method: 'POST',
        path: '/admin/broadcasts/preview',
        body: BroadcastTarget,
        response: BroadcastPreview,
    },
    broadcast: {
        method: 'POST',
        path: '/admin/broadcasts',
        body: BroadcastInput,
        response: BroadcastResult,
    },
};
//# sourceMappingURL=routes.js.map